export const PAGE_STRUCTURE = Object.freeze({
  ORDINARY: "ordinary",
  PERSISTENT: "persistent",
  SPECIALIZED: "specialized",
  EXCLUDED: "excluded",
});

const DESKTOP_ROUTE_STRUCTURES = Object.freeze([
  { pattern: /^\/$/, structure: PAGE_STRUCTURE.SPECIALIZED },
  { pattern: /^\/report\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/summary\/spare-part\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/inventory\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/transfer\/?$/, structure: PAGE_STRUCTURE.SPECIALIZED },
  { pattern: /^\/hold\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/usage\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/audit\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/service\/?$/, structure: PAGE_STRUCTURE.EXCLUDED },
  { pattern: /^\/service\/(?:sold|rental|stock)\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/service\/cannibal\/?$/, structure: PAGE_STRUCTURE.SPECIALIZED },
  { pattern: /^\/service\/(?:sold|rental|stock)\/deleted\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/service\/tickets\/[^/]+(?:\/edit)?\/?$/, structure: PAGE_STRUCTURE.PERSISTENT },
  { pattern: /^\/service\/audit\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/quotations\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/quotations\/deleted\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/quotations\/create\/?$/, structure: PAGE_STRUCTURE.PERSISTENT },
  { pattern: /^\/quotations\/create\/(?:sq|mq|cq)\/?$/, structure: PAGE_STRUCTURE.PERSISTENT },
  { pattern: /^\/quotations\/deleted\/[^/]+\/?$/, structure: PAGE_STRUCTURE.PERSISTENT },
  { pattern: /^\/quotations\/(?!(?:create|deleted)(?:\/|$))[^/]+(?:\/edit)?\/?$/, structure: PAGE_STRUCTURE.PERSISTENT },
  { pattern: /^\/firmware\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/profile\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/manage-users\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
  { pattern: /^\/master-data\/(?:technicians|device-models)\/?$/, structure: PAGE_STRUCTURE.ORDINARY },
]);

export function desktopRouteStructure(pathname) {
  return DESKTOP_ROUTE_STRUCTURES.find(({ pattern }) => pattern.test(pathname))?.structure || PAGE_STRUCTURE.EXCLUDED;
}

export function desktopContentPadding(pathname) {
  return desktopRouteStructure(pathname) === PAGE_STRUCTURE.PERSISTENT ? "p-0" : "p-8";
}

export { DESKTOP_ROUTE_STRUCTURES };
